import { hasPermission } from '@/utils/permissions';

export function canAdjustCredit(permissions) {
  return hasPermission(permissions, 'admin');
}
